import React from 'react'
import NetworkingBriefProvider, {
  useNetworkingBrief,
} from './NetworkingBriefProvider'
import { TemplateProvider, initializeTemplates } from '../../lib/pdf'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'
import * as T0 from './Template0'

// These need to be declared outside of a component so they can't affect rendering
const [templates, templateStyle, templateSupportedStyles] = initializeTemplates(
  [T0],
)

const StandaloneViewer = ({ locale, ...props }) => {
  const { template_settings, template_index } = props
  const defaultStyle = template_settings
    ? {
        ...templateStyle,
        [`template-${template_index}`]: template_settings,
      }
    : templateStyle
  const templateProps = {
    templates,
    defaultStyle,
    templateSupportedStyles,
    template_index,
  }

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.NetworkingBriefBuilder"
    >
      <TemplateProvider {...templateProps}>
        <NetworkingBriefProvider locale={locale} {...props}>
          <div id="resume-pdf-preview" className="relative md:flex-grow">
            <div className="w-full md:sticky md:left-0 md:top-0 md:h-screen">
              <PdfViewer {...props} />
            </div>
          </div>
        </NetworkingBriefProvider>
      </TemplateProvider>
    </TranslationProvider>
  )
}
export default StandaloneViewer

const PdfViewer = ({ HideToolBar }) => {
  const {
    pdf: { url, loading },
  } = useNetworkingBrief()

  const viewerUrl = HideToolBar
    ? `${url}#toolbar=0&navpanes=0`
    : `${url}#navpanes=0`

  if (loading) {
    return null
  }
  return (
    <iframe
      src={viewerUrl}
      className="h-full w-full"
      title="Resume Preview"
      frameBorder="0"
      loading="lazy"
    />
  )
}
